import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsClient from './components/Settings/SettingsClient'
import OnboardStep from './components/Onboard/OnboardStep'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class OnboardClientContainer extends Component {

  render() {
    return <OnboardStep pathname="/onboard/location" {...this.props}>
      <SettingsClient {...this.props} />
    </OnboardStep>
  }

}

export default connect((state) => ({ settings: state.onboard }), mapDispatchToProps)(OnboardClientContainer)
